import React from 'react';
import InspectionDetail from 'Component/pages/components/inspection-detail';
import QualityInspectionListDetailRoute from './route';
import './style.scss';

const noop = () => {};
export default class QualityInspectionListDetailTemplate extends QualityInspectionListDetailRoute {
    render() {
        let { sdkOptions, location } = this.props;
        let {
            detail,
            smartTags,
            changeList,
            qualityCheckScoreSaving,
            caseBase,
            relatedDatas,
            relatedLoading,
            pointChildrenComputer,
            pointChildrenPerson,
            resetStatus,
            dialogRemarkList,
            activeCallId,
            related,
            relatedRecordsLoading,
            renderLoading,
            wrapDom,
            isInformationCollect,
            showHit,
            taskId,
            id,
        } = this.privates;
        let { relatedDatasPaging } = this.privates.storages;
        let { actions } = this;
        let hasFeature = sdkOptions.props.task ? sdkOptions.props.task._hasFeature : null;

        return (
            // <div className="quality-inspection-list-detail-page">
            <div className="udesk-qa-web-page">
                <div className="udesk-qa-web-page-body" ref={wrapDom}>
                    <div className="udesk-qa-web-page-body-root quality-inspection-list-detail-page">
                        <div className="udesk-qa-layout-main-page">
                            <div className="udesk-qa-layout-main-page-body">
                                <div className="third-party-quality-inspection-list-detail-page-body qa-react-page-body">
                                    <InspectionDetail
                                        thirdParty={true}
                                        rerenderOptimization={true}
                                        evaluateChange={actions.evaluateChange}
                                        resetStatus={resetStatus}
                                        handMarkMap={actions.handMarkMap}
                                        pointChildrenComputer={pointChildrenComputer}
                                        pointChildrenPerson={pointChildrenPerson}
                                        keywords={sdkOptions.props._keywords}
                                        testSetList={this.privates.testSetList}
                                        testSetListFlag={this.privates.testSetListFlag}
                                        caseBaseStatus={true}
                                        onUpdate={actions.onUpdate}
                                        id={id}
                                        caseBase={caseBase}
                                        caseLibraryId={location.search}
                                        taskId={taskId}
                                        hasFeature={hasFeature}
                                        detail={detail}
                                        smartTags={smartTags}
                                        changeList={changeList}
                                        qualityCheckScoreSaving={qualityCheckScoreSaving}
                                        onQualityCheckScoreCancel={
                                            actions.qualityCheckScoreCanceled
                                        }
                                        onQualityCheckScoreSave={actions.qualityCheckScoreSaved}
                                        onQualityCheckScoreSubmit={
                                            actions.qualityCheckScoreSubmitted
                                        }
                                        relatedDatas={relatedDatas}
                                        relatedDatasPaging={relatedDatasPaging}
                                        parentLoadMore={actions.parentLoadMore}
                                        relatedLoading={relatedLoading}
                                        dialogRemarkList={dialogRemarkList}
                                        changeDialogRemarkList={actions.changeDialogRemarkList}
                                        querryChangeList={actions.querryChangeList}
                                        querrySmartTags={actions.querrySmartTags}
                                        isWechatQa={this.privates.isWechatQa}
                                        changeToHighlightItemsCallDetail={
                                            related ? actions.changeCallDetail : noop
                                        }
                                        // onUpdated={actions.onUpdated}
                                        refresh={actions.reloadAsyncModel}
                                        // rerenderOptimization={true}
                                        requestRelatedRecords={actions.requestRelatedRecords}
                                        relatedRecordsLoading={relatedRecordsLoading}
                                        loading={renderLoading}
                                        isInformationCollect={isInformationCollect}
                                        trainRecords={
                                            this.props.route.name === 'qualityInspectionListDetail'
                                                ? actions.trainRecords
                                                : undefined
                                        }
                                        showHit={showHit}
                                        onShowHitChange={actions.showHitChange}
                                        indexPointTag={
                                            !related
                                                ? detail.indexPointTag
                                                : this.privates.relatedIndexPointTagMap[
                                                      activeCallId
                                                  ]
                                        }
                                        onRedoSmartTags={actions.redoSmartTags}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
